import { Panel, PanelType } from 'office-ui-fabric-react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import React, { Component } from 'react';
import Scriba from 'react-scriba';
import { DataLot } from '../../data/DataLot.jsx';
import { MaxLengths } from '../../data/MaxLenghts';
import { Immocom } from '../../specifique/immocom';
import { ComboBoxEtage } from '../ComboBox/ComboBoxEtage';
import { ComboBoxExposition } from '../ComboBox/ComboBoxExposition';
import { ComboBoxLotType } from '../ComboBox/ComboBoxLotType';
import { ComboBoxNature } from '../ComboBox/ComboBoxNature';
import { EUIComboBox } from '../EUI/EUIComboBox.jsx';
import { EUITextField } from '../EUI/EUITextField';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import './FicheLotCommercial.css';

/****************************************************************
 PROPS:
    idLot
    onAffichePanelFicheLot
    onFermeFicheLot : méthode
****************************************************************/

var objetState = {
    idLot: 0,
    lot: {},
    tauxTVA: 0,

    titrePanel: 'Créer un lot',

    onDesactivePrixMaitrise: true,

    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',
    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: ''
};

export class FicheLot extends Component {
    _creationContent() {
        return (
            <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12" name="divNumero">
                    <EUITextField
                        label="Numéro"
                        maxLength={MaxLengths.lot.numero}
                        onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, 'lot', 'numero', newValue, this._onVerificationFormulaire)}
                        required
                        value={this.state.lot.numero}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6" name="divNature">
                    <ComboBoxNature
                        onChange={(event, option, index, value, item) => {
                            const lot = { ...this.state.lot, idNature: option.key, idLotType: 0 };
                            this.setState({ lot }, this._onVerificationFormulaire);
                        }}
                        required
                        selectedKey={this.state.lot.idNature}
                    />
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6" name="divTypeLot">
                    <ComboBoxLotType
                        disabled={!(this.state.lot.idNature > 0)}
                        idNature={this.state.lot.idNature}
                        onChange={(event, option) => Scriba.state().setObjetPropriete(this, 'lot', 'idLotType', option.key, this._onVerificationFormulaire)}
                        required
                        selectedKey={this.state.lot.idLotType}
                    />
                </div>
                {this.state.lot.idNature === 6 || this.state.lot.idNature === 7 || this.state.lot.idNature === 8 || this.state.lot.idNature === 9 || this.state.lot.idNature === 15 ?
                    null :
                    <div className="ms-Grid-col ms-sm12" name="divNumCoPro">
                        <EUITextField
                            label="Numéro de copro"
                            maxLength={MaxLengths.lot.numCoPro}
                            onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, 'lot', 'numCoPro', newValue, this._onVerificationFormulaire)}
                            value={this.state.lot.numCoPro}
                        />
                    </div>
                }
                {this.state.lot.idNature === 6 || this.state.lot.idNature === 7 || this.state.lot.idNature === 8 || this.state.lot.idNature === 9 || this.state.lot.idNature === 15 ?
                    null :
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divNombreTantiemes">
                        <TextField // Note KP : TextFieldNombre en cours de test
                            label="Nombre de tantième"
                            value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lot', 'nombreTantiemes', false, 0)}
                            onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lot', 'nombreTantiemes')}
                            onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lot', 'nombreTantiemes', e.target.value, 'fr', this._onVerificationFormulaire)}
                            onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'nombreTantiemes', e, false, 0)}
                            deferredValidationTime={0}
                        />
                    </div>
                }
                {this.state.lot.idNature === 6 || this.state.lot.idNature === 7 || this.state.lot.idNature === 8 || this.state.lot.idNature === 9 || this.state.lot.idNature === 15 ?
                    null :
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divBaseTantiemes">
                        <EUIComboBox
                            idValeurParDefaut="0"
                            label="Base tantièmes"
                            onChange={(event, option) => Scriba.state().setObjetPropriete(this, 'lot', 'baseTantiemes', option.key, this._onVerificationFormulaire)}
                            options={[
                                { key: '1000', text: '1000' },
                                { key: '10000', text: '10000' }
                            ]}
                            selectedKey={this.state.lot.baseTantiemes}
                        />
                    </div>
                }
                {this.state.lot.idNature === 15 ?
                    null :
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divEtage">
                        <ComboBoxEtage
                            onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, 'lot', 'etage', option.key, this._onVerificationFormulaire)}
                            required={this.state.lot.idNature === 1}
                            selectedKey={this.state.lot.etage}
                        />
                    </div>
                }
                {this.state.lot.idNature === 3 || this.state.lot.idNature === 4 ?
                    null :
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divExposition">
                        <ComboBoxExposition
                            onChange={(event, option, index, value, item) => Scriba.state().setObjetPropriete(this, 'lot', 'exposition', option.key, this._onVerificationFormulaire)}
                            required={this.state.lot.idNature === 1}
                            selectedKey={this.state.lot.exposition}
                        />
                    </div>
                }
                <div className="ms-Grid-col ms-sm12 ms-md6" name="divSurfaceHabitable">
                    <TextField // Note KP : TextFieldNombre en cours de test
                        label="Surface habitable"
                        required={this.state.lot.idNature === 1 || this.state.lot.idNature === 5 || this.state.lot.idNature === 6 || this.state.lot.idNature === 7 || this.state.lot.idNature === 8 || this.state.lot.idNature === 9 || this.state.lot.idNature === 15}
                        value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lot', 'surfaceHabitable', false, 2)}
                        onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lot', 'surfaceHabitable')}
                        onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lot', 'surfaceHabitable', e.target.value, 'fr', this._onVerificationFormulaire)}
                        onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'surfaceHabitable', e, false, 2)}
                        deferredValidationTime={0}
                        suffix="m²"
                    />
                </div>
                {(this.state.lot.idNature >= 6 && this.state.lot.idNature <= 12) || this.state.lot.idNature === 15 ?
                    null :
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divBatiment">
                        <EUITextField
                            label="Bâtiment"
                            maxLength={MaxLengths.lot.batiment}
                            onDelayedChange={(event, newValue) => Scriba.state().setObjetPropriete(this, 'lot', 'batiment', newValue, this._onVerificationFormulaire)}
                            value={this.state.lot.batiment}
                        />
                    </div>
                }
                {this.state.lot.idNature === 1 || this.state.lot.idNature === 2 || this.state.lot.idNature === 15 ?
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divNombreSalleDeBain">
                        <TextField // Note KP : TextFieldNombre en cours de test
                            label="Nombre de salle de bain"
                            value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lot', 'nombreSalleDeBain', false, 0)}
                            onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lot', 'nombreSalleDeBain')}
                            onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lot', 'nombreSalleDeBain', e.target.value, 'fr', this._onVerificationFormulaire)}
                            onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'nombreSalleDeBain', e, false, 0)}
                            deferredValidationTime={0}
                        />
                    </div>
                    : null
                }
                {this.state.lot.idNature == 1 || this.state.lot.idNature === 2 || this.state.lot.idNature === 15 ?
                    <div className="ms-Grid-col ms-sm12 ms-md6" name="divNombreWC">
                        <TextField // Note KP : TextFieldNombre en cours de test
                            label="Nombre de WC"
                            value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lot', 'nombreWC', false, 0)}
                            onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lot', 'nombreWC')}
                            onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lot', 'nombreWC', e.target.value, 'fr', this._onVerificationFormulaire)}
                            onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'nombreWC', e, false, 0)}
                            deferredValidationTime={0}
                        />
                    </div>
                    : null
                }
                {this.state.lot.idNature === 3 || this.state.lot.idNature === 4 || this.state.lot.idNature === 5 || this.state.lot.idNature === 6 || this.state.lot.idNature === 7 || this.state.lot.idNature === 8 || this.state.lot.idNature === 9 || this.state.lot.idNature === 10 || this.state.lot.idNature === 15 ?
                    null :
                    <div className="ms-Grid-col ms-sm12" name="divPrixMobilierHT">
                        <TextField // Note KP : TextFieldNombre en cours de test
                            label="Prix mobilier HT"
                            value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lot', 'prixMobilierHT', false, 2)}
                            onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lot', 'prixMobilierHT')}
                            onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lot', 'prixMobilierHT', e.target.value, 'fr', this._onVerificationFormulaire)}
                            onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'prixMobilierHT', e, false, 2)}
                            deferredValidationTime={0}
                            suffix="€"
                        />
                    </div>
                }
                <div className="ms-Grid-col ms-sm12" name="divPrixHT">
                    <TextField // Note KP : TextFieldNombre en cours de test
                        label="Prix HT"
                        required={this.state.lot.idNature < 6 || this.state.lot.idNature > 10}
                        value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lot', 'prixHT', false, 12, 2)}
                        onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lot', 'prixHT')}
                        onBlur={e => this._calculPrixTTC(e.target.value)}
                        onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'prixHT', e, false, 2)}
                        deferredValidationTime={0}
                        suffix="€"
                    />
                </div>
                {this.state.lot.idNature === 6 || this.state.lot.idNature === 7 || this.state.lot.idNature === 8 || this.state.lot.idNature === 9 || this.state.lot.idNature === 10 || this.state.lot.idNature === 15 ?
                    null :
                    <div className="ms-Grid-col ms-sm12" name="divPrixMaitriseHT">
                        <TextField // Note KP : TextFieldNombre en cours de test
                            label="Prix maîtrisé HT"
                            disabled={this.state.onDesactivePrixMaitrise}
                            value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lot', 'prixMaitriseHT', false, 2)}
                            onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lot', 'prixMaitriseHT')}
                            onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lot', 'prixMaitriseHT', e.target.value, 'fr', this._onVerificationFormulaire)}
                            onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'prixMaitriseHT', e, false, 2)}
                            deferredValidationTime={0}
                            suffix="€"
                        />
                    </div>
                }
                {this.state.lot.idNature === 6 || this.state.lot.idNature === 7 || this.state.lot.idNature === 8 || this.state.lot.idNature === 9 || this.state.lot.idNature === 10 ?
                    null :
                    <div className="ms-Grid-col ms-sm12" name="divPrixTTC">
                        <TextField // Note KP : TextFieldNombre en cours de test
                            label="Prix TTC"
                            required={this.state.lot.idNature === 1 || this.state.lot.idNature === 2 || this.state.lot.idNature === 15}
                            value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lot', 'prixTTC', false, 2)}
                            onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lot', 'prixTTC')}
                            onBlur={e => this._calculPrixHT(e.target.value)}
                            onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'prixTTC', e, false, 2)}
                            deferredValidationTime={0}
                            suffix="€"
                        />
                    </div>
                }
                {this.state.lot.idNature === 6 || this.state.lot.idNature === 7 || this.state.lot.idNature === 8 || this.state.lot.idNature === 9 || this.state.lot.idNature === 10 || this.state.lot.idNature === 15 ?
                    null :
                    <div className="ms-Grid-col ms-sm12" name="divLoyerAnnuelHT">
                        <TextField // Note KP : TextFieldNombre en cours de test
                            label="Loyer annuel HT"
                            value={Scriba.officeUI().textField().nombre().ValeurChampNombreObjetAvecPrecisionAfficheeSpecifiee(this, 'lot', 'loyerAnnuelHT', false, 2)}
                            onFocus={() => Scriba.officeUI().textField().nombre().onFocusTextFieldNombreObjet(this, 'lot', 'loyerAnnuelHT')}
                            onBlur={e => Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lot', 'loyerAnnuelHT', e.target.value, 'fr', this._onVerificationFormulaire)}
                            onGetErrorMessage={e => Scriba.officeUI().textField().nombre().onGetErrorMessageTextFieldNombre(this, 'loyerAnnuelHT', e, false, 2)}
                            deferredValidationTime={0}
                            suffix="€"
                        />
                    </div>
                }

                {this.state.lot.idLot == null ? null :
                    <div className="ms-Grid-row">
                        <div className="ms-Grid-col ms-sm12 divDateCreationModification">
                            {this.state.lot.creerLe !== null ?
                                <div className="ms-Grid-col ms-sm12">
                                    Créé le {Scriba.date().stringDateFormatCourt(this.state.lot.creerLe)} par {this.state.lot.creerPar}
                                </div>
                                : null
                            }
                            {this.state.lot.modifierLe !== null ?
                                <div className="ms-Grid-col ms-sm12">
                                    Modifié le {Scriba.date().stringDateFormatCourt(this.state.lot.modifierLe)} par {this.state.lot.modifierPar}
                                </div>
                                : null
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }

    constructor(props) {
        super(props);

        this.state = objetState;
    }

    _onInit() {
        this.setState(objetState);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheLot();
    }

    _chargementDonnees() {
        this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: "Chargement du lot" });

        var chargementLot = DataLot._chargementLot(this.props.idLot);

        chargementLot
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;
                    let lotTrav = objetData[0];

                    lotTrav.prixHT = parseFloat(lotTrav.prixHT).toFixed(12);

                    if (lotTrav.prixMaitriseHT !== null) {
                        lotTrav.prixMaitriseHT = parseFloat(lotTrav.prixMaitriseHT).toFixed(2);
                    }

                    if (lotTrav.loyerAnnuelHT !== null) {
                        lotTrav.loyerAnnuelHT = parseFloat(lotTrav.loyerAnnuelHT).toFixed(2);
                    }

                    // Ticket 1443 - Par défaut à 1
                    if (lotTrav.idLot <= 0) {
                        if (lotTrav.nombreSalleDeBain == null) {
                            lotTrav.nombreSalleDeBain = 1;
                        }

                        if (lotTrav.nombreWC == null) {
                            lotTrav.nombreWC = 1;
                        }
                    }

                    let stateTemp = {};
                    stateTemp.idLot = this.props.idLot;
                    stateTemp.lot = lotTrav;
                    stateTemp.tauxTVA = objetData[2];
                    stateTemp.titrePanel = (lotTrav.idLot > 0 ? 'Modifier le lot ' + lotTrav.numero : 'Créer un lot');
                    stateTemp.onDesactivePrixMaitrise = (objetData[1] !== 3);

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);

                    //if (lotTrav.idLot !== 0)
                    this._calculPrixTTC(lotTrav.prixHT);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onVerificationFormulaire() {
        Immocom.fiche()._validationFormulaire(this, 'Lot', this.state.lot, (this.state.lot.idLot > 0 ? 'Modification' : 'Création'));
    }

    _onEnregistrement = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Enregistrement du lot en cours'
        });

        let enregistrementLot = DataLot._onEnregistrementLot(this.state.lot, this.state.idLot);

        enregistrementLot
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                    this.props.onFermeFicheLot();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _calculPrixTTC(prixHT) {
        let prixTTC = (prixHT * (1 + parseFloat(this.state.tauxTVA))).toFixed(2);

        let lot = { ...this.state.lot };
        lot.prixTTC = prixTTC;

        // If you want a function to be executed after the state change occurs, pass it in as a callback
        this.setState({ lot: lot }, function () {
            Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lot', 'prixHT', prixHT, 'fr', this._onVerificationFormulaire)
        });
    }

    _calculPrixHT(prixTTC) {
        var prixHT = (prixTTC / (1 + parseFloat(this.state.tauxTVA))).toFixed(12);


        let lot = { ...this.state.lot };
        lot.prixHT = prixHT;

        // If you want a function to be executed after the state change occurs, pass it in as a callback
        this.setState({ lot: lot }, function () {
            Scriba.officeUI().textField().nombre().onBlurTextFieldNombreObjet(this, 'lot', 'prixTTC', prixTTC, 'fr', this._onVerificationFormulaire);

        });
    }

    _onRenderFooterContent = () => {
        let boutonActif = this.state.onActiveBoutonEnregistrer;

        return (
            <div>
                <PrimaryButton name="btnEnregistrerLot" onClick={() => this._onEnregistrement()} className="marginRight8px" disabled={!boutonActif}>Enregistrer</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Fermer</DefaultButton>
            </div>
        );
    };

    componentDidMount() {
    }

    _onOpen = () => {
        this._chargementDonnees();
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
    }

    render() {
        let content = this._creationContent();

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText={this.state.titrePanel}
            isOpen={this.props.onAffichePanelFicheLot}
            onDismiss={() => this._onAnnulation()}
            onOpen={() => this._onOpen()}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.medium}
        >
            <div className={this.props.classname}>
                <div className={this.props.classnameinner}>
                    <div className="ms-Grid" dir="ltr">
                        <MessageBars
                            errorMessage={this.state.errorMessage}
                            warningMessage={this.state.warningMessage}
                            onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                            onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                        />

                        {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                        {content}
                    </div>
                </div>
            </div>
        </Panel>;
    }
}
